<div class="amd-main__header">
  <span class="amd-main__title">{{
    "accountManagement.dialog.contracts.title" | translate
  }}</span>
</div>
<div class="amd-main__content flex flex-col gap-4">
  @if (loadingContracts()) {
    @for (item of [1, 2, 3]; track item) {
      <p-skeleton
        width="100%"
        height="110px"
        styleClass="my-2 rounded-2xl"
      ></p-skeleton>
    }
  } @else {
    @for (contract of contracts(); track contract) {
      <app-contract-card
        [name]="contract.literal ?? ''"
        [tipoId]="contract.TIPO_ID"
        [startDate]="contract.FCIERT_DT_PARSED"
        [showCertificateButton]="!!contract.showCertificateButton"
        [showDeactivateButton]="contract.showDeactivateButton ?? true"
        (closeDialog)="closeDialog.emit()"
      ></app-contract-card>
    }
    @if (!contracts().length) {
      <app-empty-message
        class="mt-8"
        [title]="'accountManagement.dialog.contracts.noContracts'"
      />
    }
  }
</div>
